import { AccountChat } from "./accountChatsParser"
import { driverJid } from "../jidUtils"

/**
 * Resolves the actual current driver JID for a chat room.
 *
 * MUC JIDs are often named after the original driver (e.g.
 * "vitalii@drivers.host"), so the room JID is not evidence of who drives now.
 * The account chat config is:
 *
 * - `driverA` has a value → that is the driver
 * - the chat is in the account chats registry but carries no `driverA` → the
 *   seat is empty, whether it was cleared or never filled
 * - the chat is not in the registry at all → nothing to go on, so the room JID
 *   is read as a last resort. Shared rooms from another vhost and rooms seen
 *   before the registry loads land here.
 */
export function resolveDriverJidForChat(
  accountChat: AccountChat | undefined,
  roomJid: string,
): string | undefined {
  if (!accountChat) return driverJid(roomJid)
  return accountChat.driverA || undefined
}
